import React, { useEffect, useState } from "react";
import "./analysisDashboard.css";
import { MdModeComment, MdPersonAdd, MdRemoveRedEye } from "react-icons/md";
import Sidebar from "./sidebar";
import { useNavigate } from "react-router-dom";
import Signup from "../../Auth/signup";
import Login from "../../Auth/login";
import analystService from "../../../components/Services/analyst.service";
import AddCommentBox from "./addCommentBox";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { toastProperties } from "../../../commons/Toast/Toaster";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import landingCostCalculatorService from "../../../components/Services/landingCostCalculator.service";
import { Col, Row } from "react-bootstrap";

const Dashboard = () => {
  // const configKey = useSelector(state => state?.sessionState?.connectionName)
  const configKey = localStorage.getItem("CONNECTION_NAME");
  const dispatch = useDispatch();
  const [showSignUpModal, setShowSignUpModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [addCommentBox, setAddCommentBox] = useState([]);
  const [companyProfiles, setCompanyProfiles] = useState([]);
  const [userPage, setUserPage] = useState(false);
  const navigate = useNavigate();
  const handleSignUpPopup = () => {
    setShowSignUpModal(true);
  };

  const handleSignUpClose = () => {
    setShowSignUpModal(false);
  };

  const handleLoginPopup = () => {
    setShowLoginModal(true);
  };
  const handleLoginClose = () => {
    setShowLoginModal(false);
  };

  const handleAddComment = (index) => {
    const updatedAddCommentBoxes = [...addCommentBox];
    updatedAddCommentBoxes[index] = !updatedAddCommentBoxes[index];
    setAddCommentBox(updatedAddCommentBoxes);
  };

  const getAllCompanyProfiles = () => {
    analystService.getAllCompanyProfiles().then((response) => {
      if (response?.data?.code === 200) {
        setCompanyProfiles(response?.data?.data);
      }
    });
  };
  const handleUserProfileEdit = (item) => {
    navigate("/analyst_registration");
    setUserPage(true);
    localStorage.setItem("UserDetails", JSON.stringify(item));
  };
  useEffect(() => {
    getAllCompanyProfiles();
    localStorage.removeItem("VERIFIED_EMAIL");
  }, []);

  const [configStatus, setConfigStatus] = useState(
    configKey === "Bid" ? true : false
  );
  const handleSwitchChange = (checked) => {
    setConfigStatus(checked);
    const reqBody = {
      config: checked === true ? "Bid" : "Connection",
    };
    analystService
      .changeConnectionName(reqBody)
      .then((response) => {
        if (response?.data?.code === 200) {
          localStorage.setItem(
            "CONNECTION_NAME",
            response?.data?.data?.connectionName
          );
          toast.success(response?.data?.message, toastProperties);
        }
      })
      .catch((err) => console.log("Config Status: ", err));
  };
  return (
    <>
      <div className="full-screen-bg">
        <Sidebar />
        {
          // userPage ? <GnaRegistration /> :
          <section className="dashboard-area">
            <div className="switch-row">
              <div className="analysis-page-title mb-3">Registered User</div>

              {/* <div>
                <div className="analysis-page-title mb-2">Configuration</div>

                <BootstrapSwitchButton
                  checked={configStatus}
                  onlabel=""
                  onstyle="primary"
                  offlabel="Connection&nbsp;&nbsp;"
                  offstyle="success"
                  onChange={handleSwitchChange}
                />
              </div> */}
            </div>
            <div>
              <div className="users-view-wrap">
                <div className="users-view-wrap-row">
                  <div className="users-view-wrap-card">
                    <div className="user-view-icon-box user-view-icon-box-orange">
                      <img src="images/analysis-1.png" alt="analysis" />
                    </div>
                    <div className="total-users">
                      Total no. of Consumers
                      <span>{companyProfiles?.consumerCount}</span>
                    </div>
                  </div>
                  <div className="users-view-wrap-card">
                    <div className="user-view-icon-box user-view-icon-box-green">
                      <img src="images/analysis-2.png" alt="analysis" />
                    </div>
                    <div className="total-users">
                      Total no. of Generators
                      <span>{companyProfiles?.generatorCount}</span>
                    </div>
                  </div>
                </div>
                <div className="table-filters">
                  <div className="add-new-user" onClick={handleSignUpPopup}>
                    <MdPersonAdd className="me-2" /> Add New User
                  </div>
                </div>
              </div>
            </div>
            <hr className=" horizontal-line" />
            <div className="table-responsive doc-cus-table">
              <table className="cus-table table-bordered my-documents-table bg-white mt-3">
                <thead className="table-header">
                  <tr>
                    <th>S. No.</th>
                    <th>Application Details</th>
                    <th>Date of Registration</th>
                    <th>Account Types</th>
                    <th>Application Status</th>
                    <th>View Profile</th>
                    {/* <th>Add Comment</th> */}
                  </tr>
                </thead>
                <tbody>
                  {companyProfiles?.companyResponse?.map((item, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td width="20%">{item?.companyName}</td>
                      <td>{item?.createdAt}</td>
                      <td>
                        {item?.accountTypes
                          ?.map(
                            (type) =>
                              type.charAt(0).toUpperCase() +
                              type.slice(1).toLowerCase()
                          )
                          .join(", ")}
                      </td>
                      <td>
                        {item?.accountStatus?.charAt(0).toUpperCase() +
                          item?.accountStatus?.slice(1).toLowerCase()}
                      </td>
                      <td>
                        <MdRemoveRedEye
                          size={25}
                          className="action-edit-btn"
                          onClick={() => {
                            handleUserProfileEdit(item);
                          }}
                        />
                      </td>
                      {/* <td>
                      {addCommentBox[i] ? (
                        <div>
                          <AddCommentBox />
                        </div>
                      ) : (
                        <MdModeComment
                          className="action-comment-btn"
                          onClick={() => handleAddComment(i)}
                        />
                      )}
                    </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {showSignUpModal && (
              <Signup
                handleSignUpClose={handleSignUpClose}
                handleLoginPopup={handleLoginPopup}
                showSignUpModal={showSignUpModal}
              />
            )}

            {showLoginModal && (
              <Login
                showLoginModal={showLoginModal}
                handleLoginClose={handleLoginClose}
              />
            )}
          </section>
        }
      </div>
    </>
  );
};

export default Dashboard;
